<template>
    <div class="d-flex flex-column justify-content-center">
        <div class="w-100 pb-2">
            <label
                for="buttonTarget"
                class="font-14"
            >
                Abrir em
            </label>

            <select
                name="buttonTarget"
                id="buttonTarget"
                class="form-control"
                v-model="item.frameContent.settings.target"
                @change="onChangeButtonTarget"
            >
                <option v-for="target in buttonTargets" :key="target.value" :value="target.value">
                    {{ target.name }}
                </option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingFrameButtonTarget',
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            buttonTargets: {
                1: { name: "Nova aba", value: '_blank' },
                2: { name: "Mesma aba", value: '_self' }
            },
        }
    },
    methods: {
        onChangeButtonTarget() {
            this.$emit('onChangeButtonTarget', this.item)
        },
    },
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameButtonTarget.vue